import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-auto-ml',
  templateUrl: './auto-ml.component.html',
  styleUrls: ['./auto-ml.component.scss']
})
export class AutoMlComponent {

  constructor(
    public _autoMl:AutoMlService,
    private toast:ToastrService
  ){}

  scrollToTop(){
    if(!this._autoMl.isValidDepVariable){
      const id = document.getElementById('run-automl');
      id?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
    }
  }

  renameIterate(uuid:string,name:string){
    const data = {
      name:name
    }
    this._autoMl.renameIterateName(uuid,data)
    .subscribe((res:any)=>{
      this.toast.success(res.message)
      this._autoMl.getTableDetails();
      this._autoMl.comparisonData();
    })
  }

  deleteIteration(uuid:string,i:number){
    if(uuid!==''){
      this._autoMl.deleteIteration(uuid)
      .subscribe((res:any)=>{
        this.toast.success(res.message)
        this._autoMl.iterationSet.splice(i,1);
        this._autoMl.getTableDetails();
        this._autoMl.comparisonData();
      })
    }else{
      this._autoMl.iterationSet.splice(i,1);
    }
  }
}
